import React, { useEffect, useState } from 'react';
import Sidebar from './components/SideBar';
import Alert from './components/Alert';
import { HashRouter, Navigate, Route, Routes } from 'react-router-dom';
import {
  Login,
  OwnerShopDetails
} from './pages';
import UserState from './components/UserState';
import { useSelector } from 'react-redux';


function App() {
  const user = useSelector((state) => state.userController.user);
  const [theme, setTheme] = useState('light');

  const toggleTheme = () => {
    setTheme((prev) => {
      if (prev === 'light') {
        window.localStorage.setItem('theme', 'dark');
        return 'dark';
      } else {
        window.localStorage.setItem('theme', 'light');
        return 'light';
      }
    });
  };

  useEffect(() => {
    const storageTheme = window.localStorage.getItem('theme');
    if (storageTheme) {
      setTheme(storageTheme);
    }
  }, []);

  const ownerRoutes = (
    <>
      <Route path="/" element={<OwnerShopDetails />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </>
  );

  return (
    <main className={`App ${theme}`}>
      <HashRouter>
        <Alert />
        {user && <Sidebar theme={theme} toggleTheme={toggleTheme} />}
        <UserState />
        <Routes>
          <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
          {!user && <Route path="*" element={<Navigate to="/login" replace />} />}
          {user?.role === 'owner' && ownerRoutes}
        </Routes>
      </HashRouter>
    </main>
  );
}

export default App;
